import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import layout from "./modules/layout";
import list from "./modules/list";
import status from "./modules/status";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    layout,
    app,
    list,
    status,
  },
});
